var React = require('react');

function PenTool (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 19L19 12L22 15L15 22L12 19Z","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M18 13L16.5 5.5L2 2L5.5 16.5L13 18L18 13Z","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M2 2L9.586 9.586","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M11 13C12.1046 13 13 12.1046 13 11C13 9.89543 12.1046 9 11 9C9.89543 9 9 9.89543 9 11C9 12.1046 9.89543 13 11 13Z","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

PenTool.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = PenTool;

PenTool.default = PenTool;
